import { CREATE_ORDER, CREATE_ORDER_SUCCESS, CREATE_ORDER_FAILURE, CLEAR_ORDER_CONFIRMATION } from '../types';

const initialState = {
  loading: false,
  orderConfirmation: null,
  error: null
};

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ORDER:
      return {
        ...state,
        loading: true,
        error: null
      };
    case CREATE_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        orderConfirmation: action.payload,
        error: null
      };
    case CREATE_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        orderConfirmation: null,
        error: action.error
      };
    case CLEAR_ORDER_CONFIRMATION:
      return {
        ...state,
        orderConfirmation: null,
        error: null
      };
    default:
      return state;
  }
};

export default orderReducer;
